import { GeneratedReportsType } from './types';

export const initialContextValue: GeneratedReportsType = {
  notifications: undefined,
};
